<mat-card *ngIf="processing">
  <span>Loading</span>
  <br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<!-- Associated Households -->
<div fxLayout="row wrap" class="matero-row" [hidden]="households == false && processing == false">
  &nbsp;&nbsp;
  <span *ngIf="housingUnitId > 0 && !authService.isReadOnly()">
    <button id="btnWaterSystem" mat-raised-button color="primary" title="Associate a Household to this Housing Unit" (click)="associateHouseholdToHousingUnit()" *ngIf="!authService.isReadOnly()">
      <mat-icon>add</mat-icon> Associate a Household to this Housing Unit</button>
  </span>
</div>

<mat-card [hidden]="households == false && processing == false">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Associated Households ({{resultSize}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTableHouseholds($event)" placeholder="Filter results" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSourceHouseholds" matSort #TableSortHousehold="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-header-row *matHeaderRowDef="displayedColumnsHouseholds"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsHouseholds;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA <br /> Household <br />
          Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a title="Edit {{result.id}}" (click)="editHousehold(result.id)">{{result.id}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="contactName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.contactName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="address1">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.address1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.city}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="zip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.zip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="county">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.county}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.householdHousingUnitStartDate}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="endDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>End Date</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.householdHousingUnitEndDate}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a href="javascript:void(0)" *ngIf="housingUnitId > 0 && !authService.isReadOnly()" (click)="disassociateFromHousingUnit(result.householdHousingUnitKey)"
            title="Remove Household {{result.id}}">
            <mat-icon>delete</mat-icon>
          </a>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginatorHousehold="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>

<!-- Associated Housing Units -->
<div fxLayout="row wrap" class="matero-row">
  &nbsp;&nbsp;
  <button mat-raised-button color="primary" title="Associate a Housing Unit to this Well" (click)="associateHousingUnitToWell()"
    *ngIf="wellId > 0 && !authService.isReadOnly()"><mat-icon>add</mat-icon> Associate a Housing Unit to this Well</button>
</div>
<br />
<mat-card [hidden]="housingUnits == false && processing == false">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Associated Housing Units ({{resultSize}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTableHousingUnits($event)" placeholder="Filter results" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSourceHousingUnits" matSort #TableSortHousingUnit="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-header-row *matHeaderRowDef="displayedColumnsHousingUnits"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsHousingUnits;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA <br />Housing <br />Unit Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a title="Edit  {{result.id}}" (click)="editHousingUnit(result.id)">{{result.id}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="contactName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.contactName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="address1">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.address1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.city}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="zip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.zip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="county">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.county}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a href="javascript:void(0)" *ngIf="wellId > 0 && !authService.isReadOnly()" (click)="disassociateFromWell(result.wellHousingUnitKey)" title="Remove Housing Unit {{result.id}}">
            <mat-icon>delete</mat-icon>
          </a>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginatorHousingUnit="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>

<!-- Associated Wells -->
<div fxLayout="row wrap" class="matero-row" [hidden]="wells == false && processing == false">
  &nbsp;&nbsp;
  <button id="btnAssociateWell" mat-raised-button color="primary" title="Associate a Well to this Housing Unit" (click)="associateWellToHousingUnit()"
    *ngIf="!authService.isReadOnly()"><mat-icon>add</mat-icon> Add a Well to this Housing Unit</button>
</div>
<br />

<mat-card [hidden]="wells == false && processing == false">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Associated Wells ({{resultSizeWell}})</strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTableWells($event)" placeholder="Filter results" matInput />
    </mat-form-field>
    <a (click)="load()"><mat-icon>refresh</mat-icon> </a>
    <br />
    <br />
    <mat-table [dataSource]="dataSourceWells" matSort #TableSortWell="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-header-row *matHeaderRowDef="displayedColumnsWells"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnsWells;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA <br />Well Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a [routerLink]="['/well/edit/', result.id]" title="Edit Well {{result.id}}">{{result.id}}</a>
          <!-- <a title="Edit Well {{result.id}}" (click)="editWell(result.id)">{{result.id}}</a> -->
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">Address</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="20">
          {{result.address1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.city}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="state">
        <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.state}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="zip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.zip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="county">
        <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.county}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellLog">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Log</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellLog}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="tag">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.tag}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a href="javascript:void(0)" (click)="disassociateFromWell(result.wellHousingUnitKey)" title="Remove Well {{result.id}}" *ngIf="!authService.isReadOnly()">
            <mat-icon>delete</mat-icon>
          </a>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginatorWell="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>